export default (theme) => ({
  tableSection: {
    // marginLeft: 260,
  },
  TableTitle: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 0,
    color: "#606060",
    marginTop: 10,
    marginLeft: 25,
  },
  tabStyle: {
    borderBottom: "1px solid rgba(0,0,0,.1)",
    paddingLeft: 25,
  },
});
